<flx-heading-with-instructions [title]="title" [instructions]="instructions"></flx-heading-with-instructions>
<div class="btn-list-container">
	<ng-container *ngFor="let button of buttons">
		<flx-button [color]="button.color" size="small" (click)="handleClickEvent(button.clickHandler, $event)">{{ button.text }}</flx-button>
	</ng-container>
</div>
